import { render, staticRenderFns } from "./ActivatedPurchase.vue?vue&type=template&id=172ebbca&scoped=true&"
import script from "./ActivatedPurchase.vue?vue&type=script&lang=js&"
export * from "./ActivatedPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ActivatedPurchase.vue?vue&type=style&index=0&id=172ebbca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172ebbca",
  null
  
)

export default component.exports